import type { VoidFunctionComponent } from 'react';

import Card from '../../generic/Card/Card';
import HorizontalBarGraph from '../../generic/Graphs/HorizontalBarGraph';
import type { BarData } from '../../generic/Graphs/HorizontalBarGraph';
import type { StatusBreakdown } from '../../../../shared/types/routes/issueCounts';
import { abbrevNumber, prettyNumber } from '../../../utils/numbers';
import Tooltip from '../../generic/Tooltip';

import styles from '../IssueOverview.module.less';

type Props = {
  title: string;
  status?: StatusBreakdown;
  data: BarData[];
};

const CategoryGraph: VoidFunctionComponent<Props> = ({ data, status, title }) => {
  return (
    <Card variant="fill" isFullWidth isContentFullHeight>
      <Card.Header>{title}</Card.Header>
      <Card.Content>
        <div className={styles.breakdown}>
          <HorizontalBarGraph showTooltips data={data} yAxisConfig={{ width: 105 }} />
          <div className={styles.statusSection}>
            <div>
              <span className={styles.label}>Not Shown:</span>
            </div>
            <div>
              <Tooltip
                id="remediated-count"
                tooltip={`Ignored: ${status?.ignored ? prettyNumber(status.ignored) : 'n/a'}`}
              >
                <span>
                  <span className={styles.label}>Ignored </span>
                  <span className={styles.count}>{status?.ignored !== undefined ? abbrevNumber(status.ignored) : 'n/a'}</span>
                </span>
              </Tooltip>
            </div>
            <div>
              <Tooltip
                id="remediated-count"
                tooltip={`Remediated: ${status?.remediated ? prettyNumber(status.remediated) : 'n/a'}`}
              >
                <span>
                  <span className={styles.label}>Remediated </span>
                  <span className={styles.count}>{status?.remediated !== undefined ? abbrevNumber(status.remediated) : 'n/a'}</span>
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
      </Card.Content>
    </Card>
  );
};

export default CategoryGraph;
